import React, { cloneElement, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PrimaryButton from '../../../ui/PrimaryButton';
import ActionButton, { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';

import useFunctionKeys from '../../../hooks/useFunctionKeys';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import useSystemSettings from '../../../hooks/useSystemSettings';
import BicInfoAreaHistory from '../../common/BicInfoAreaHistory';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import * as XCol from "../../../framework.core/XExportColumn";
import { NavigationType, openNewPage } from '../../../util/navigationHelpers';
import { crdbList, TableColumn, TableSettings } from '../../../tableSettings';
import constants from '../../../constants';
import ApplicationContext from '../../../ApplicationContext';
import lockRed from '../../../img/lock_red.png';
import {
  CurrencyAmountRenderer,
  DateRenderer,
  DateTimeRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,
  TextAlignRightRenderer,
  TextRenderer,
} from '../../../uiControls/SmartTableRenderers';
import CheckBoxUncontrolled from '../../../ui/CheckBoxUncontrolled';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import AbstractListView, { DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer } from "../../common/AbstractListView";
import { Search } from '../../../filtering';
import { getJobNameFromInvBillCrDbJobType, getOpTypeConstant, JobNames } from '../../../framework.core/JobNames';
import { CrDbListItem } from '../../../fms.data/models/CrDbListItem';
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BicTypeFilterRenderer, DraftFilterRenderer, PeriodRenderer, RecognizedFilterRenderer, RecognizedRenderer, StatusNotUseFileLockedRenderer, VoidFilterRenderer } from '../../common/commonListRenderers';
import { FmsSecTask } from '../../../fms.core/constants';
import AgentBalanceDetails from '../../reports/AccountBalance';
import { nowDate } from '../../../dateUtils';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask, getSecBySecTask } from '../../../util';
import useSuntekSettings from '../../../hooks/useSuntekSettings';
import { getFmsGlobal } from '../../../globals';
import BatchPrint from '../../reports/BatchPrint';
import { FormType, SecType } from '../../../fms.enum';
import HistoryView from '../../reports/HistoryView';
import { DocumentType } from "../../../framework.core/DocumentType";
import { CRDBArgs } from '../../../fms.report/args';
import useReportViewer from '../../../hooks/useReportViewer';
import { useJournal } from '../general/journal/JournalListView';
import { FmsSecCntr } from '../../../fms.core/constants/FmsSecCntr';
import { CurrencyAmountValue, nullableCheckBoxValue } from '../../common/commonExportFormat';

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;


  return (
    //<div className="ifms-table-default" style={{ width: '100%', minHeight: '22px', cursor: 'pointer' }} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function DraftRenderer({ cell }: any) {
  if (cell && cell.value) {
    return (
      <div data-tooltip={'Draft'} className="ifms-table-default">
        <span style={{ color: 'green' }}>V</span>
      </div>
    );
  }

  return <div className="ifms-table-default"></div>;
}

function VoidRenderer({ cell }: any) {
  if (cell && cell.value === true) {
    return (
      <div data-tooltip={'Void'} className="ifms-table-default">
        <span style={{ color: 'red' }}>V</span>
      </div>
    );
  }

  return <div className="ifms-table-default"></div>;
}

function ConfirmedRenderer({ value, row }: any) {
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const suntekSettings = useSuntekSettings();

  if(jobListContext.opType === constants.opTypes.warehousing){
    let secCont = appContext.securityControls ? appContext.securityControls[JobNames.WHCrDb] : null;
    if (!secCont) {
      secCont = [
        { secCntr: FmsSecCntr.WHCrDbConfirmed, contName: 'chkSettled' },
        { secCntr: FmsSecCntr.WHCrDbDraft, contName: 'chkDraft' }
    ];
      appContext.setSecurityControls(JobNames.WHCrDb, secCont);
    }
  }else{
    let secCont = appContext.securityControls ? appContext.securityControls[JobNames.CrDb] : null;
    if (!secCont) {
      secCont = [
        { secCntr: FmsSecCntr.CrDbConfirmed, contName: 'chkSettled' }
    ];
      appContext.setSecurityControls(JobNames.CrDb, secCont);
    }
  }


  async function updateConfirmed(newValue: boolean) {
    await appContext.api.setCrdbConfirmed(row.original.id, newValue);
    row.original.settled = newValue;
    jobListContext.updateDataRow(row.original);
  }

  function findClickedCell(element: Element): Element | null {
    for (let i = 0; i < 6; ++i) {
      if (!element) {
        break;
      }
      if (Array.from(element.classList).some(className => className.startsWith('row-'))) {
        return element;
      }
      element = element.parentNode as Element;
    }
    return null;
  }

  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <CheckBoxUncontrolled
        key={row.original.id}
        initialValue={Boolean(value)}
        onChange={updateConfirmed}
        disabled={appContext.getControlDisableStatus(jobListContext.opType === constants.opTypes.warehousing?JobNames.WHCrDb:JobNames.CrDb, 'chkSettled', FormType.ModeEdit) || suntekSettings.accounting?.disableConfirmInCRDBList}
        allowOnChange={async (e) => {
          if (!e) return false;

          e?.stopPropagation();

          const element = findClickedCell(e.currentTarget);
          if (!element) {
            await showGlobalOkDialog(<p>Cannot find hover element</p>, false, null, 'warning');
            return false;
          }

          const classes = element.classList;
          const mouseOverRowIndex = Array.from(classes).find(className => className.includes('row-'))?.match(/\d+$/)?.[0];

          if (!mouseOverRowIndex || !jobListContext.data) {
            await showGlobalOkDialog(<p>Cannot find hover data</p>, false, null, 'warning');
            return false;
          }

          const rowData = jobListContext.data[parseInt(mouseOverRowIndex)];
          if (rowData.void > 0) {
            await showGlobalOkDialog(<p>This CrDb has been voided.</p>);
            return false;
          } else if (rowData.paidAmt !== 0) {
            await showGlobalOkDialog(<p>This CrDb has been already paid.</p>);
            return false;
          } else if (rowData.draft) {
            await showGlobalOkDialog(<p>This CrDb is Draft.</p>);
            return false;
          } else {
            return true;
          }
        }} />
    </div>
  );
}

function formatData(data: Array<CrDbListItem>) {
  return data.map((d: CrDbListItem) => ({
    ...d,
    status: d.draft ? '' : d.status
  }));
}

function useCrdbOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  //<pt220130: Change to use switchToList()
  // function switchToHbl(jobName: JobNames, refNo:string) {
  //   const opType = getOpTypeConstant(jobName);
  //   jobListContext.setFilterForScreenExternally(`/common/joblistview/hbl/${opType}`, 'refNo', 'Ref No', refNo, 'updated', false);
  //   openNewPage(history, `/common/joblistview/hbl/${opType}`, NavigationType.newPage);
  // }

  // function switchToMbl(jobName: JobNames, mblNo:string) {
  //   const opType = getOpTypeConstant(jobName);
  //   jobListContext.setFilterForScreenExternally('/common/joblistview/mbl/oceanImport', 'mblNo', 'Mbl No', mblNo, 'updated', false);
  //   openNewPage(history, `/common/joblistview/mbl/oceanImport`, NavigationType.newPage);
  // }
  function switchToList(jobName: JobNames, jobId: number, refNo: string, hblNo: string) {
    // const blType = isMasterJob(jobName) ? 'mbl' : 'hbl';
    let blType = '';
    let columnLabel = '';
    let columnIdEx = null;
    let textEx = null;
    switch(jobName) {
      case JobNames.OIMbl:
        blType = 'mbl';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.OIHbl:
        blType = 'hbl';
        columnLabel = 'HBL #';
        columnIdEx = 'hblNo';
        textEx = hblNo;
        break;
      case JobNames.OEMbl:
        blType = 'oeMbl';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.OEHbl:
        blType = 'oeHbl';
        columnLabel = 'HBL #';
        columnIdEx = 'hblNo';
        textEx = hblNo;
        break;
      case JobNames.AIMbl:
        blType = 'aiMawb';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.AIHbl:
        blType = 'aiHawb';
        columnLabel = 'HAWB #';
        columnIdEx = 'hawbNo';
        textEx = hblNo;
        break;
      case JobNames.AEMbl:
        blType = 'aeMawb';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.AEHbl:
        blType = 'aeHawb';
        columnLabel = 'HAWB #';
        columnIdEx = 'hawbNo';
        textEx = hblNo;
        break;
      case JobNames.OtherOP:
        blType = 'otherShipment';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.WHRcv:
        blType = 'whReceiving';
        columnLabel = 'Receiving ID';
        columnIdEx = 'receiveNo';
        textEx = refNo;
        break;
      case JobNames.WHShip:
        blType = 'whShipping';
        columnLabel = 'Shipping ID';
        columnIdEx = 'shipNo';
        textEx = refNo;
        break;
    }
    const opType = getOpTypeConstant(jobName);
    jobListContext.setFilterForScreenExternally(`/common/joblistview/${blType}/${opType}`, 'id', columnLabel, jobId.toString(), 'update', false, true, null, columnIdEx, textEx, false,true);
    openNewPage(history, `/common/joblistview/${blType}/${opType}`, NavigationType.newPage);
  }

  function switchToParentFor(crdb: CrDbListItem) {
    if (!crdb) {
      return;
    }
    if(crdb.jobType === '') return;
    // if (crdb.type === JobNames.OIMbl) {
    //   switchToMbl(crdb.parentNo ?? '');
    // }
    // if (crdb.type === JobNames.OIHbl) {
    //   switchToHbl(crdb.refNo ?? '');
    // }
    switchToList(getJobNameFromInvBillCrDbJobType(crdb.jobType), crdb.tbId, crdb.refNo, crdb.hblNo);
  }

  return { switchToParentFor };
}

function useSelectedCrdbOperations() {
  const fmsGlobal = getFmsGlobal();
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const { switchToParentFor } = useCrdbOperations();

  const selectedElement = jobListContext.selectedElement as CrDbListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function create() {
    if(jobListContext.opType !== constants.opTypes.warehousing) return;

    if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/periodCrdb/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, '/accounting/periodCrdb/add', NavigationType.newPage);
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    if (!selectedElement.jobType && selectedElement.period !== "P") {
     // await showGlobalOkDialog(<p>Operation currently not implemented for this type</p>);
      return;
    }

    const id = selectedElement.id;

    let editUrl = `/accounting/crdb/edit/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${id}`;
    if (!selectedElement.jobType && selectedElement.period === "P") editUrl = `/accounting/periodCrdb/edit/${id}`;
    let viewUrl = `/accounting/crdb/view/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${id}`;
    if (!selectedElement?.jobType && selectedElement.period === "P") viewUrl = `/accounting/periodCrdb/view/${id}`;

    // // Edit 창은 하나만 열리도록 수정
    // if (jobListContext.hasOpenedScreenInAnyOperationStartingWithUrlWithoutMe(editUrl.substring(0, editUrl.indexOf('/edit')+5), editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    if (!selectedElement.jobType && selectedElement.period !== "P") {
      //await showGlobalOkDialog(<p>Operation currently not implemented for this type</p>);
      return;
    }

    const id = selectedElement.id;

    let editUrl = `/accounting/crdb/edit/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${id}`;
    if (!selectedElement.jobType && selectedElement.period === "P") editUrl = `/accounting/periodCrdb/edit/${id}`;
    
    let viewUrl = `/accounting/crdb/view/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${id}`;
    if (!selectedElement.jobType && selectedElement.period === "P") viewUrl = `/accounting/periodCrdb/view/${id}`;
  
    const isWarehouingList = jobListContext.opType === constants.opTypes.warehousing;
    const listSec = findSecurityTask(appContext, (isWarehouingList ? FmsSecTask.WHCrDb : FmsSecTask.AcctCrDbList));
    const urls = [viewUrl];
    if(listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  function switchToParent() {
    const selectedElement = jobListContext.selectedElement as CrDbListItem;
    switchToParentFor(selectedElement);
  }

  async function deleteItem() {
    if (!selectedElement) {
      await showGlobalOkDialog('Cannot delete!',false,null,'warning');
      return;
    }

    if (!selectedElement.jobType && selectedElement.period === "P") {
      if (
        jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/periodCrdb/edit/${selectedElement.id}`) || 
        jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/periodCrdb/view/${selectedElement.id}`)
      ) {
        await showGlobalOkDialog('Need to close Cr/Db first', false, null, "warning");
        return;
      }
    }
    else {
      if (
        jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/crdb/edit/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${selectedElement.id}`) || 
        jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/crdb/view/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${selectedElement.id}`)
      ) {
        await showGlobalOkDialog('Need to close Cr/Db first', false, null, "warning");
        return;
      }
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.CrDb, { id: selectedElement.id, opAcctBlockAfterClosed: fmsGlobal?.OPAcctBlockAfterClosed??false });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  async function viewPaymentHistory() {
    if (!selectedElement) {
      return;
    }

    const jobId = selectedElement.id;
    const jobName = JobNames.CrDb;
    const jobType = selectedElement.jobType

    const viewUrl = `/accounting/acPaymentHistoryView/${jobName}/${jobId}/${getJobNameFromInvBillCrDbJobType(jobType)}`;
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  return { create, edit, view, switchToParent, deleteItem, viewPaymentHistory };
}

function RightClickMenu({ dismiss }: { dismiss: VoidFunction }) {
  const { create, edit, view, deleteItem, switchToParent } = useSelectedCrdbOperations();
  const jobListContext = useContext(JobListViewContext);

  const isWarehouingList = jobListContext.opType === constants.opTypes.warehousing;
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, (isWarehouingList ? FmsSecTask.WHCrDb : FmsSecTask.AcctCrDbList));
  // const isDraft =  jobListContext.selectedElement.draft;

  const items = [ 
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd || !isWarehouingList},
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: isWarehouingList ? 'Go to W/H List' : 'Go to BL List', shortcut: 'F6', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];
  const menuItems: ActionButtonItem[] = items.map((i, index) => ({
    label: <ToolboxMenuItem name="crdb-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item: IfmsMenuItem) {
    if (!isWarehouingList)
      switch (item.index) {
        case 1:
          view();
          break;
        case 2:
          edit();
          break;
        case 3:
          deleteItem();
          break;
        case 4:
          jobListContext.triggerTableSearch('F5');
          break;
        case 5:
          switchToParent();
          break;
        case 6:
          jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
          break;
        case 7:
          jobListContext.reloadData();
          break;
        default:
          break;
      }
    //warehousing
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteItem();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        switchToParent();
        break;
      case 6:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 7:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as CrDbListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if ((!suntekSettings.general?.allowViewJournalBillings && !userId.startsWith('@')) || jobListContext.opType !== constants.opTypes.warehousing) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.CrDb, selectedElement.id)}>
       {constants.List_Journal}
    </PrimaryButton>
  );
}

function CrdbListCommands() {
  const history = useHistory();
  const { viewReport } = useReportViewer();
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem | null>(null);

  const [showGlobalOkDialog] = useGlobalOkDialog();

  const selectedElement = jobListContext.selectedElement as CrDbListItem;

  const { edit, view, deleteItem, viewPaymentHistory } = useSelectedCrdbOperations();

  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHCrDb :FmsSecTask.AcctCrDbList));
  const hasSecCp = getSecBySecTask(appContext, FmsSecTask.AcctCustPayment, SecType.Add);
  const hasSecBp = getSecBySecTask(appContext, FmsSecTask.AcctBillPayment, SecType.Add);

  const hasSelectedRow = !!selectedElement;

  //const { viewReport } = useReportViewer();

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function print() {
    if (!selectedElement) {
      return;
    }

    const title = `Cr/Db Note [CrDb #: ${selectedElement?.crDbNo}][Ref. #: ${selectedElement.refNo}]`;
    const args = new CRDBArgs({
      docType: DocumentType.CRDB,
      formCaption: title,
      subject: title,

      tbId: selectedElement?.id.toString() ?? '',
      tbName: "T_CRDBHD",
      toCompanyid: selectedElement?.agentId.toString()
    });
    viewReport(args, "", true);
  }

  async function onCustomerBillAction(item: ActionButtonItem) {
    let link = '';
    switch (item.index) {
      case 0:
        link = `/accounting/acCustomerPayment/add`;
        break;
      case 1:
        link = `/accounting/acBillPayment/add`;
        break;
      case 2:

      jobListContext.setFilterForScreenExternally('/common/joblistview/acCustomerPayment/accounting', 
        'invoiceNo', 'Billings', selectedElement.crDbNo, 'updated', false, true, null);
        openNewPage(history, '/common/joblistview/acCustomerPayment/accounting', NavigationType.newPage);
        return;
      case 3:
      jobListContext.setFilterForScreenExternally('/common/joblistview/acBillPayment/accounting', 
        'invoiceNo', 'Billings', selectedElement.crDbNo, 'updated', false, true, null);
        openNewPage(history, '/common/joblistview/acBillPayment/accounting', NavigationType.newPage);
        return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(link)) {
      await showGlobalOkDialog(<p>Payment New Operation is already in progress</p>);
      return;
    }

    openNewPage(history, `${link}/${selectedElement.agentId}`, NavigationType.newPage);
  }

  
  function onHistoryBtnAction(item: ActionButtonItem) {
    switch (item.index) {
      case 0:
        viewPaymentHistory();
        break;
      case 1:
        setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1200, popupComponent: <HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={JobNames.CrDb} /> })
        break;
      // case 2:
      //   setSelectedPopupMenuItem({ label: 'Delete History (CrDb)', popupWidth: 920, popupComponent: <HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={JobNames.CrDb} viewDeleteHistory={true} /> })
      //   return;
    }
  }

  async function agentBalance() {
    if (selectedElement.agentId <= 0) {
      await showGlobalOkDialog(<p>You didn't enter Agent.</p>,false,null,'warning');
      return;
    }
    setSelectedPopupMenuItem({
      label: 'Balance',
      popupWidth: 780,
      popupComponent:
        <AgentBalanceDetails
          jobId={selectedElement.id}
          jobName={jobListContext.opType === constants.opTypes.warehousing ? JobNames.WHCrDb : JobNames.CrDb}
          onPopupClose={onPopupClose}
          //toDate={invoice.postDate || ''}
          toDate={nowDate()}
          comId={selectedElement.agentId}
          comType={'C'}
          branch={''}
          subCode={''}
          customerName={selectedElement.agent}
        />
    })
  }

  function hasOpenedViewOrEditFor(id: number) {
    if (!selectedElement.jobType && selectedElement.period === "P") 
      return jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/periodCrdb/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/periodCrdb/view/${id}`);
    return jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/crdb/edit/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/crdb/view/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${id}`);    
  }

  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const disablePrint = !hasSelectedRow;//&& selectedElement.draft; //<240523.dwshin Invoice/Bill/CRDB - Draft인 항목을 출력 할 때, Title에 Draft 나오도록 추가>

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        {/* <chuck date="2025-02-13" Git="3.3-2414" desc="Hide the Add button temporary" /> */}
        {/* {(jobListContext.opType === constants.opTypes.warehousing) &&
          <><UniqueLinkButton name='crdb-list-add-button' display="primary" size="regular" link="/accounting/periodCrdb/add" disabled={!canBeAdd} label="New" />&nbsp;&nbsp;</>
        } */}
        <PrimaryButton name='crdb-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='crdb-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='crdb-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteItem}>Delete</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        {jobListContext.opType === constants.opTypes.warehousing && <>
          <PrimaryButton name='crdb-list-print-button' size="regular" disabled={disablePrint} onClick={print}>Print</PrimaryButton>&nbsp;
          <PrimaryButton
            name='crdb-list-batchPrint-button'
            size="regular"
            disabled={disablePrint}
            onClick={() => setSelectedPopupMenuItem({ label: 'CrDb Batch Print', popupComponent: <BatchPrint selectedElement={selectedElement} documentType={DocumentType.CrDbBatch} jobName={JobNames.RptCrDbBatch} /> })}
          >
            Batch Print
          </PrimaryButton>&nbsp;
          {(hasSecCp || hasSecBp) &&
            <>
              <ActionButton
                name='crdb-list-pay-button'
                type="primary"
                items={[
                  { label: 'New Customer Pay', separator: false, index: 0, hidden: !hasSecCp, name: "crdb-list-sub-custpay-button" },
                  { label: 'New Bill Pay', separator: true, index: 1, hidden: !hasSecBp, name: "crdb-list-sub-billpay-button" },
                  { label: 'Customer Pay List', separator: false, index: 2, hidden: !hasSecCp, name: "crdb-list-sub-custpayList-button" },
                  { label: 'Bill Pay List', separator: false, index: 3, hidden: !hasSecBp, name: "crdb-list-sub-billpayList-button" },
                ]}
                onItemSelected={onCustomerBillAction}
              >
                Pay
              </ActionButton>&nbsp;
            </>
          }
          <>
            <ActionButton
              name='crdb-list-viewhistory-button'
              type="primary"
              items={[
                { label: 'Payment History', separator: false, index: 0, hidden: !hasSelectedRow, name: "crdb-list-payment-button" },
                { label: 'View History', separator: false, index: 1, hidden: !hasSelectedRow, name: "crdb-list-history-button" },
              ]}
              onItemSelected={onHistoryBtnAction}
            >
              View History
            </ActionButton>&nbsp;
          </>
          {/* <PrimaryButton size="regular" disabled={!hasSelectedRow} onClick={() => setSelectedPopupMenuItem({ label: 'Payment History', popupWidth: 1050, popupComponent: <PaymentHistory jobId={selectedElement.id} jobName={JobNames.CrDb} /> })}>Payment History</PrimaryButton>&nbsp; 
          <PrimaryButton name='crdb-list-payment-button' disabled={!hasSelectedRow} size="regular" onClick={viewPaymentHistory}>Payment History</PrimaryButton>&nbsp;
          <PrimaryButton name='crdb-list-history-button' size="regular" disabled={!hasSelectedRow} onClick={() => setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1200, popupComponent: <HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={JobNames.CrDb} viewDeleteHistory={false} /> })}>View History</PrimaryButton>&nbsp;*/}
        </>}

        {jobListContext.opType !== constants.opTypes.warehousing && (
          <>
            <PrimaryButton
              name='billings-crdb-list-print-button'
              size="regular"
              disabled={!hasSelectedRow}
              onClick={print}>
              Print
            </PrimaryButton>&nbsp;
          </>
        )}
        <PrimaryButton
          name='crdb-list-agentBalance-button' 
          size="regular"
          disabled={!hasSelectedRow} 
          onClick={agentBalance}>
          Balance
        </PrimaryButton>
      </div>

      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function CrdbListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function CrdbListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({ onFunction: onFunctionKey });

  const jobListContext = useContext(JobListViewContext);
  const systemSettings = useSystemSettings();
  const appContext = useContext(ApplicationContext);
  const isWarehouingList = jobListContext.opType === constants.opTypes.warehousing;
  const listSec = findSecurityTask(appContext, (isWarehouingList ? FmsSecTask.WHCrDb : FmsSecTask.AcctCrDbList));

  const { edit, view, switchToParent, create } = useSelectedCrdbOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
    if (!unprocessedFkey) {
      return;
    }

    doProcessFkey();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToParent();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F3', 'F9', 'F11', 'F8', 'F2'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  async function loadCrdbHistory(param: any) {
    //const apiResult = await appContext.api.getOceanImportCrdbHistory(id);
    const apiResult = await appContext.api.getAcctHistory(param.jobName, param.jobId, (jobListContext.selectedElement as CrDbListItem).jobType, false);
    if (!apiResult || !apiResult.success) {
      return null;
    }

    return <BicInfoAreaHistory context="crdb" historyData={apiResult.result} primaryCurrency={systemSettings?.primaryCurrency ?? ''} />
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.CrDb}
      jobId={(jobListContext.selectedElement as CrDbListItem | null)?.id ?? 0}
      customTabs={[
        {
          headline: '',
          contentLoader: loadCrdbHistory,
          params: { appContext, jobListContext }
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

/**
 * Concrete implementation for CRDB (OI) List screen
 *
 * @class CrdbListView
 * @extends {AbstractListView}
 */
class CrdbListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const useBranch = systemSettings?.enableBranch ?? false;
    let listType: JobNames.CrDb | JobNames.WHCrDb = JobNames.CrDb;
    if (opType === constants.opTypes.warehousing) {
      listType = JobNames.WHCrDb;
    }

    const tsettings = crdbList;
    const cols = CrDbListItem.getExportCollection(listType, useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u2Date',
      orderByAscending: false,
    };
  }

  getCustomFilterRenderers(opType?: string | undefined): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'recognized',
        renderer: RecognizedFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'jobType',
        renderer: (props: any) => <BicTypeFilterRenderer opType={opType} {...props} />,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      //{
      //  accessor: 'draft',
      //  renderer: DraftFilterRenderer,
      //  searchValueExtractor: (v: any | null | undefined) => v === 'D' ? true : false,
      //},
      // {
      //   accessor: 'void',
      //   renderer: VoidFilterRenderer,
      //   searchValueExtractor: (v: any | null | undefined) => v === 'V' ? true : false,
      // },
      {
        accessor: 'settled',
        renderer: undefined,
        searchValueExtractor: (v: any | null | undefined) => v.value !== undefined ? v.value : v,
      },
    ];
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    let listType: JobNames.CrDb | JobNames.WHCrDb = JobNames.CrDb;
    if (opType === constants.opTypes.warehousing) {
      listType = JobNames.WHCrDb;
    }

    return CrDbListItem.getExportCollection(listType, useBranch).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if (x.dataIndex === "draft") {
        // colRenderer.Cell = DraftRenderer;
        colRenderer.Cell = NullableCheckboxIconRenderer;
      }
      else if (x.dataIndex === 'recognized') {
        colRenderer.Cell = RecognizedRenderer;
      }
      // else if (x.dataIndex === "void") {
      //   colRenderer.Cell = VoidRenderer;
      // }
      else if (x.dataIndex === "period") {
        colRenderer.Cell = PeriodRenderer;
      }
      else if (x.dataIndex === "amount" || x.dataIndex === "paidAmt" || x.dataIndex === "balance" || x.dataIndex === "total" || x.dataIndex === "dutyAmount"|| x.dataIndex === "creditTotal"|| x.dataIndex === "debitTotal") {
        colRenderer.Cell = props => <CurrencyAmountRenderer currencyAccessor={(x: any) => x.currency} {...props} />;
      }
      else if (x.dataIndex === "settled") {
        colRenderer.Cell = ConfirmedRenderer;
      }
      else if (x.dataIndex === "refNo" || x.dataIndex === "hblNo") {
        colRenderer.Cell = TextAlignLeftRenderer;
      }
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }

  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'draft', changedValue: (value: any) => { return nullableCheckBoxValue(value['draft'])}});
    colRenderer.push({ accessor: 'settled', changedValue: (value: any) => { return nullableCheckBoxValue(value['settled'])} });
    colRenderer.push({ accessor: 'amount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['amount']) } });
    colRenderer.push({ accessor: 'paidAmt', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['paidAmt']) } });
    colRenderer.push({ accessor: 'balance', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['balance']) } });
    colRenderer.push({ accessor: 'total', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['total']) } });
    colRenderer.push({ accessor: 'dutyAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['dutyAmount']) } });
    colRenderer.push({ accessor: 'creditTotal', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['creditTotal']) } });
    colRenderer.push({ accessor: 'debitTotal', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['debitTotal']) } });
    return colRenderer;
  }

  async fetchAndFormatData(api: any, search: Search, opType: string | undefined): Promise<DataFetchResult> {
    const searchModel = CrDbListItem.calculateSearchParameters(search, CrDbListItem.MapSearchFields);
    if (opType === constants.opTypes.oceanImport) searchModel.extraWhere = JobNames.OceanImport;
    else if (opType === constants.opTypes.oceanExport) searchModel.extraWhere = JobNames.OceanExport;
    else if (opType === constants.opTypes.airImport) searchModel.extraWhere = JobNames.AirImport;
    else if (opType === constants.opTypes.airExport) searchModel.extraWhere = JobNames.AirExport;
    else if (opType === constants.opTypes.otherShipment) searchModel.extraWhere = JobNames.OtherOP;

    const apiResult = await api.getListItems(opType === constants.opTypes.warehousing ? JobNames.WHCrDb : JobNames.CrDb, 'CrDbListItem',
      searchModel,
      1,
      search.pageSize,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return { data: [], totalCount: 0 };
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount };
  }

  renderCommands(): React.ReactNode {
    return (
      <CrdbListCommands />
    );
  }

  renderBeforeConfigureButton(): React.ReactNode {
    return (
      <CrdbListToolbar />
    );
  }



  renderExtras(hideLogHistory: boolean): React.ReactNode {
    return (
      <CrdbListViewExtras hideLogHistory={hideLogHistory} />
    );
  }

  getViewUrlFor(row: CrDbListItem) {
    if (!row.jobType && row.period !== "P") {
      return '';  // Not supported
    }
    if (!row.jobType && row.period === "P")
      return { url: row && row.id ? `/accounting/periodCrdb/view/${row.id}` : '', needAfterScreenUrl: true };
    else
      return { url: row && row.id ? `/accounting/crdb/view/${getJobNameFromInvBillCrDbJobType(row.jobType)}/${row.tbId}/${row.id}` : '', 
        needAfterScreenUrl: true, checkAllOperation: true };
  }

  getListViewTitle(opType: string | undefined) {
    return 'CrDb List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.CrDb} keyProp='id' />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
  
  useLogHistory(): boolean {
    return true;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default CrdbListView;
